import type { Guide } from '../types';

/** S-21.10-25 — region planisty: kraj i cyfry kodu według kraju (B13; scenariusze e2e 22 i 14). */
export const guide: Guide = {
  flagKey: 'regionDigitsByCountry',
  title: 'Region planisty: kraj i cyfry kodu pocztowego według kraju',
  whatItDoes:
    '„Mój region” na pulpicie planisty to kraj i pierwsze cyfry kodu pocztowego miejsc, w których zwalniają się jego pojazdy. Liczbę cyfr ustala się teraz dla każdego kraju osobno: domyślnie 2 (w dużych krajach to okolica ok. 35–60 km), w Holandii, Belgii, Szwajcarii i Danii 1. Wartości zmienia się na ekranie „Parametry rekomendacji” w sekcji „Region na pulpitach FTL”, z powodem i historią; pojazd znany tylko z pozycji GPS daje region krajowy.',
  audience: ['planista FTL', 'administrator'],
  presentationItems: ['S-21.10-25'],
  steps: [
    {
      route: '/suggestion-parameters',
      target: 'region-digits-note',
      title: 'Sekcja „Region na pulpitach FTL”',
      description:
        'Pod opisem tabela: liczba cyfr dla krajów bez własnej wartości (domyślnie 2) i wiersze krajów z wyjątkiem — NL, BE, CH i DK mają 1. Pusta wartość kraju oznacza wartość domyślną.',
      action: 'Otwórz „Parametry rekomendacji” i przewiń do sekcji „Region na pulpitach FTL”; wartość zmienisz przy wierszu, z powodem.',
      recorder: { account: 'admin' },
    },
    {
      route: '/suggestion-parameters',
      target: 'region-digits-add-country',
      title: 'Nowy kraj',
      description:
        'Kraj spoza tabeli liczy się wartością domyślną. Własną liczbę cyfr dostaje przez „Dodaj kraj”: kod kraju, cyfry (0–2) i powód — zmiana trafia do historii parametru.',
      action: 'Kliknij „Dodaj kraj”, wpisz kod kraju, liczbę cyfr i powód.',
      recorder: { account: 'admin' },
    },
    {
      route: '/ftl-planner-dashboard',
      target: 'ftl-planner-scope',
      title: 'Zakres regionu na pulpicie planisty',
      description:
        'Opis nad kafelkami mówi, jak liczy się „mój region”: wartość domyślna i kraje z inną liczbą cyfr, a za nimi regiony, w których zwalniają się Twoje pojazdy.',
      action: 'Otwórz „Pulpit planisty” i przeczytaj opis zakresu nad kafelkami.',
      recorder: { account: 'ftl' },
    },
  ],
};
